import {get, isString} from "lodash"
import domain from "@irati/utils/env/domain"
import {APIRequestConfig} from "../../API"
import setIfNotSet from "../../../setIfNotSet"
import env from "../../../env"
import {DEVELOPMENT, STAGING, LOCAL} from "../../../constants/environment"

// DO NOT ADD PRODUCTION
const ENVIRONMENT_WHITELIST: string[] = [LOCAL, DEVELOPMENT, STAGING]

/**
 * @description: Adds a query param to a graph request.
 * This has no functional use, it just makes it easier to debug in the network tab.
 */
export default function setOperationNameToParams(config: APIRequestConfig = {}) {
  const isInternalAdmin = domain.isInternal()
  if (ENVIRONMENT_WHITELIST.includes(env.ENVIRONMENT_NAME) || isInternalAdmin) {
    const {data} = config
    if (data && isString(data)) {
      const operationName = get(JSON.parse(data), "operationName")
      setIfNotSet(config, "params.opName", operationName)
    }
  }
}
